import { BehaviorSubject, Subscription } from "rxjs";
import { EndpointLayer, } from "./endpointlayer";
import { EndpointIcon } from "./endpointIcon";
export const PayloadColourRules = {
    WARN: 0,
    COMPLETE: 1,
    HEARD: 2,
    UNHEARD: 3,
};
export class ReloadRequiredError extends Error {
    constructor(message) {
        super(message);
        this.name = "ReloadRequiredError";
    }
}
export class PayloadLayer extends EndpointLayer {
    constructor() {
        super(...arguments);
        this.updates$ = new Subscription();
        this._completion = new BehaviorSubject({
            total: 0,
            complete: 0,
            heard: 0,
            error: 0,
        });
        this.completion = this._completion.asObservable();
        this.icons = [
            new EndpointIcon({ colour: "yellow", size: 5, fill: true }),
            new EndpointIcon({ colour: "", size: 5, fill: true }),
            new EndpointIcon({
                colour: "blue",
                size: 5,
                fill: false,
                style: "square",
                width: 4,
            }),
            new EndpointIcon({ colour: "red", size: 5, fill: true }),
        ];
    }
    set error(value) {
        if (value) {
            this.icons[PayloadColourRules.WARN].setStyle(value);
        }
    }
    set complete(value) {
        if (value) {
            this.icons[PayloadColourRules.WARN].setStyle(value);
        }
    }
    set heard(value) {
        if (value) {
            this.icons[PayloadColourRules.WARN].setStyle(value);
        }
    }
    set unheard(value) {
        if (value) {
            this.icons[PayloadColourRules.WARN].setStyle(value);
        }
    }
    updateRecord([index, state]) {
        try {
            this.data.data[index].state = state;
        }
        catch (e) {
            console.error(e);
            console.log("data.data", this.data.data);
            console.log(`data.data[index]`, this.data.data[index]);
            console.log("update", [index, state]);
        }
    }
    addEndpoints(load_data) {
        super.addEndpoints(load_data);
        let completion = {
            total: this.data.data.length,
            complete: 0,
            heard: 0,
            error: 0,
        };
        this.data.data.forEach((e) => {
            switch (e.state) {
                case PayloadColourRules.COMPLETE:
                    completion.complete++;
                    break;
                case PayloadColourRules.HEARD:
                    completion.heard++;
                    break;
                case PayloadColourRules.WARN:
                    completion.error++;
                    break;
            }
        });
        this._completion.next(completion);
    }
    processUpdate(update) {
        if (this.serial != update.serial ||
            update.generation - this.generation > 1) {
            throw new ReloadRequiredError("Reload Required as serial or generation do not match");
        }
        let completion = this._completion.value;
        update.updates.forEach((e) => {
            switch (e[1]) {
                case PayloadColourRules.COMPLETE:
                    completion.complete++;
                    break;
                case PayloadColourRules.HEARD:
                    completion.heard++;
                    break;
                case PayloadColourRules.WARN:
                    completion.error++;
                    break;
            }
            this.updateRecord(e);
        });
        this._completion.next(completion);
        this.generation = update.generation;
    }
    linkUpdates(updates) {
        this.updates$ = updates.subscribe({
            next: (data) => {
                try {
                    data.forEach((e) => this.processUpdate(e));
                    this.redraw();
                }
                catch (error) {
                    this.handleUpdateError(error);
                }
            },
            error: (error) => {
                this.handleUpdateError(error);
            },
        });
    }
    handleUpdateError(error) {
        if (error instanceof ReloadRequiredError) {
            this.updateEndpoints();
        }
        else {
            console.error(error);
            throw error;
        }
    }
    updateEndpoints() {
        if (this.loadEndpoints) {
            this.loadEndpoints().subscribe((d) => this.addEndpoints(d));
        }
        else {
            console.log("No meter retieval function set");
        }
    }
    setEndpointSource(source) {
        this.loadEndpoints = source;
        this.updateEndpoints();
    }
    setColorRule([unheard, heard, complete, error]) {
        this.unheard = unheard;
        this.heard = heard;
        this.complete = complete;
        this.error = error;
        this.redraw();
    }
    getIcons() {
        return this.icons;
    }
    setIcons(icons) {
        this.icons = icons;
        this.redraw();
    }
    renderItem(record) {
        return this.renderEndpointWithStyle(record, this.icons[record.state]);
    }
}
